import React from 'react';

function FeedbackCustomSettingsIcon() {
  return (
    <svg width={24} height={24} fill="none">
      <title>Ilustração de opções customizadas</title>
      <path
        d="M10.537 4.8H22.08v.96H10.54c-.167 1.794-1.406 2.88-3.34 2.88-1.935 0-3.157-1.07-3.337-2.88H1.92V4.8h1.943c.18-1.81 1.402-2.88 3.337-2.88 1.935 0 3.156 1.07 3.337 2.88zm9.6 6.72h1.943v.96h-1.94c-.167 1.794-1.406 2.88-3.34 2.88-1.935 0-3.157-1.07-3.337-2.88H1.92v-.96h11.543c.18-1.81 1.402-2.88 3.337-2.88 1.935 0 3.156 1.07 3.337 2.88zM1.92 19.2h5.303c.18 1.81 1.402 2.88 3.337 2.88 2.042 0 3.31-1.211 3.358-3.19l.002-.17v.48h8.16v-.96h-8.16v.48c0-2.1-1.26-3.36-3.36-3.36-1.935 0-3.157 1.07-3.337 2.88H1.92v.96zM4.8 5.28c0 1.57.83 2.4 2.4 2.4 1.524 0 2.363-.798 2.399-2.253V5.28c0-1.57-.83-2.4-2.4-2.4-1.569 0-2.4.83-2.4 2.4zm12 4.32c-1.57 0-2.4.83-2.4 2.4 0 1.57.83 2.4 2.4 2.4 1.524 0 2.363-.798 2.399-2.253V12c0-1.57-.83-2.4-2.4-2.4zm-8.64 9.12c0-1.57.83-2.4 2.4-2.4 1.57 0 2.4.83 2.4 2.4l-.001.147c-.036 1.455-.875 2.253-2.4 2.253-1.569 0-2.4-.83-2.4-2.4z"
        fill="#111"
      />
    </svg>
  );
}

export default FeedbackCustomSettingsIcon;
